module.exports = __webpack_public_path__ + "pic/50.6cdf84e2.png";